// extracted by extract-css-chunks-webpack-plugin
module.exports = {"new_loader_wrapper":"newSpinner__new_loader_wrapper","loader":"newSpinner__loader","spin":"newSpinner__spin"};